import React, { memo, useMemo, useState } from 'react';
import cx from 'classnames';
import Modal from 'react-modal';
import './styles.scss';
import { createCNADefaultTaskService, updateCNADefaultTaskService } from '../../../../../services/cna/default-tasks';
import { isResponseOk } from '../../../../../utility/isResponseOk';

const ManageTaskModal = ({ editTaskData, companyID, onClose, onRefetchTasks }) => {
  const [description, setDescription] = useState(editTaskData?.text ?? '');

  const isEditing = !!editTaskData;

  const isValidDescription = useMemo(() => {
    const trimDescription = description.trim();
    const trimDescriptionLength = trimDescription.length;
    const isChanged = trimDescription !== editTaskData?.text;
    return trimDescriptionLength >= 2 && trimDescriptionLength <= 255 && isChanged;
  }, [description, editTaskData?.text]);

  const handleChangeTaskDescription = (e) => setDescription(e.target.value);

  const handleAddTask = async () => {
    try {
      let response;

      if (isEditing) {
        response = await updateCNADefaultTaskService({ taskID: editTaskData?.id, taskDescription: description });
      } else {
        response = await createCNADefaultTaskService({ companyID, taskDescription: description });
      }

      if (isResponseOk(response)) {
        onClose();
        onRefetchTasks();
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Modal
      isOpen
      className={cx('modal-default cna-add-task-modal')}
      overlayClassName={'modal-overlay cna-add-task-modal-overlay'}
      onRequestClose={onClose}
      contentLabel="Example Modal"
      ariaHideApp={false}
    >
      <h2 className="modal-header">
        {`${isEditing ? 'Edit' : 'Create'} Default Task`}
        <button className="btn btn-icon" onClick={onClose}>
          <i className="icon-icon-x" />
        </button>
      </h2>
      <div className="modal-body">
        <div className="group">
          <span className={'group__title'}>
            <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2.5" y="2" width="32" height="32" rx="16" fill="#F4EBFF" />
              <rect x="2.5" y="2" width="32" height="32" rx="16" stroke="#F9F5FF" strokeWidth="4" />
              <path
                d="M21.1667 12.6693H22.5001C22.8537 12.6693 23.1928 12.8097 23.4429 13.0598C23.6929 13.3098 23.8334 13.649 23.8334 14.0026V23.3359C23.8334 23.6896 23.6929 24.0287 23.4429 24.2787C23.1928 24.5288 22.8537 24.6693 22.5001 24.6693H14.5001C14.1465 24.6693 13.8073 24.5288 13.5573 24.2787C13.3072 24.0287 13.1667 23.6896 13.1667 23.3359V14.0026C13.1667 13.649 13.3072 13.3098 13.5573 13.0598C13.8073 12.8097 14.1465 12.6693 14.5001 12.6693H15.8334M16.5001 11.3359H20.5001C20.8683 11.3359 21.1667 11.6344 21.1667 12.0026V13.3359C21.1667 13.7041 20.8683 14.0026 20.5001 14.0026H16.5001C16.1319 14.0026 15.8334 13.7041 15.8334 13.3359V12.0026C15.8334 11.6344 16.1319 11.3359 16.5001 11.3359Z"
                stroke="#7F56D9"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Default Task Information
          </span>

          <div className="group__body">
            <label className="form-label">Task</label>
            <textarea
              id="name"
              value={description}
              onChange={handleChangeTaskDescription}
              className="form-control"
              placeholder="Enter task description"
            />
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={onClose}>
          Cancel
        </button>
        <button className="btn" disabled={!isValidDescription} onClick={handleAddTask}>
          {isEditing ? 'Save' : 'Create'}
        </button>
      </div>
    </Modal>
  );
};

export default memo(ManageTaskModal);
